export default "__VITE_ASSET__DtALZoSO__"